import moment from "moment";

/**
 * Lädt den erzeugten SEPA-XML-Inhalt als Datei herunter.
 *
 * Eigenes Modul, damit der Download (inkl. Freigabe der Blob-URL) ohne Apollo/Modal-Setup
 * unit-testbar ist.
 */
export const downLoadXmlFile = ({xmlData}: {xmlData?: {xml?: string}}): void => {
    if (!xmlData?.xml) {
        return;
    }

    const blob = new Blob([xmlData.xml], {
        type: "application/xml; charset=utf-8",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    const today = moment().format("YYYY-MM-DD_HHmm");

    link.href = url;
    link.setAttribute("download", `SEPA_${today}.xml`);

    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);

    // Blob-URL wieder freigeben — sonst bleibt die komplette XML-Datei bis zum Reload im Speicher.
    window.URL.revokeObjectURL(url);
};
